import React from "react";
import UserGearIconSVG from "assets/svg/user-gear-icon";
import GraduationCapIconSVG from "assets/svg/graduation-cap-icon";
import ChatUserIconSVG from "assets/svg/chat-user-icon";
import BriefCaseExperienceIconSVG from "assets/svg/brief-case-icon";
import { Profile1 } from "constants/images";
import { FiBriefcase } from "react-icons/fi";
import { BiBuildingHouse } from "react-icons/bi";
import { FaRegUserCircle } from "react-icons/fa";
import ResumeLineDividerIconSVG from "assets/svg/resume-line-divider-icon";
import moment from "moment";
import _ from "lodash";
import { A4_SIZE } from "../../resume";
import AwardsIconSVG from "assets/svg/awards-icon";
import FileUserRepresentationIconSVG from "assets/svg/file-user-icon";
import Favicon from "components/fav-icon/Favicon";
import { useResume } from "redux/modules/resume/hooks";
import { truncateBioForTemplate } from "utils/bio-limit";
import { TEMPLATE_NAME_4 } from "constants/options";
export default function TemplateFourFullPageOne(props) {
  // ===================== props ============================
  const {
    previewImage,
    details = {},
    personal = {},
    primaryColor,
    tertiaryColor,
    totalPage=1,
    social=[]
  } = props;
  const {bio} = useResume();
  const truncatedBio = truncateBioForTemplate(bio, TEMPLATE_NAME_4);
  return (
    <div className="w-full" style={A4_SIZE}>
      <div className="w-full bg-white h-full">
        {/* ouside padding */}
        <div className="w-full h-full template-four-padding-full">
          {/* inner padding */}
          <div className="w-full h-full p-3.5 relative">
            {/* body start */}
            <div
              className="w-full flex flex-col gap-y-5">
              {/* header */}
              <div className="w-full flex flex-row justify-between items-center">
                <div className="flex flex-col gap-y-2.5">
                  <p
                    className="text-4.5xl font-bold leading-8.5 tracking-resumeName"
                    style={{ color: tertiaryColor }}>
                    {personal.name}
                  </p>
                  <div className="flex flex-row gap-x-2 text-resumeTempFourTextColor items-center">
                    {personal.hasOwnProperty("name") && personal.name && (
                      <p className="text-md leading-4">{personal.name}</p>
                    )}
                    {personal.hasOwnProperty("name") &&
                      personal.name &&
                      personal.hasOwnProperty("gender") &&
                      personal.gender && (
                        <span className="text-md opacity-30">&#8226;</span>
                      )}
                    {personal.hasOwnProperty("gender") && personal.gender && (
                      <p className="text-md leading-4">{personal.gender}</p>
                    )}
                    {personal.hasOwnProperty("gender") &&
                      personal.gender &&
                      personal.hasOwnProperty("pronoun") &&
                      personal.pronoun && (
                        <span className="text-md opacity-30">&#8226;</span>
                      )}
                    {personal.hasOwnProperty("pronoun") && personal.pronoun && (
                      <p className="text-md leading-4">{personal.pronoun}</p>
                    )}
                    {personal.hasOwnProperty("address") && personal.address && (
                      <>
                        <span className="text-md opacity-30">&#8226;</span>
                        <p className="text-md leading-4">{personal.address}</p>
                      </>
                    )}
                  </div>
                </div>
                {
                    personal?.profile_image &&
                    <>
                      <div className="w-24 h-24 rounded-2xl relative overflow-auto">
                        {personal.hasOwnProperty("profile_image") ? (
                          <img
                            src={previewImage ?? personal.profile_image}
                            className="w-full h-full object-cover object-center"
                            alt="resume-profile"
                          />
                        ) : (
                          <img
                            alt="resume-profile"
                            src={Profile1}
                            className="w-full h-full object-cover object-center"
                          />
                        )}
                      </div>
                    </>
                  }
              </div>
              {/* end header */}
              {/* Divider */}
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
              </div>
              {/* Bio — its own full-width band, directly under the name block.
                  The measure stops just short of the sheet edge so the lines
                  stay a readable length instead of running the full width. */}
              {details?.bio && (
                <>
                  <div className="w-full">
                    <p className="text-resumeTempFourTextPrimary text-md font-medium tracking-resumeFour">
                      Bio
                    </p>
                    <div className="w-full max-w-[94%] mt-1.5">
                      <div className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch line-clamp-7">
                        <div dangerouslySetInnerHTML={{ __html: truncatedBio || '' }}></div>
                      </div>
                    </div>
                  </div>
                  {/* Divider */}
                  <div className="w-full">
                    <ResumeLineDividerIconSVG full={true} />
                  </div>
                </>
              )}
              {/*  */}
              <div className="w-full">
                <div className="w-full flex flex-row gap-x-6">
                  {/* Personal Info */}
                  <div className="w-full">
                    <p className="text-resumeTempFourTextPrimary text-md font-medium tracking-resumeFour">
                      Personal Information
                    </p>
                    <div className="w-full mt-1.5">
                      <ul className="w-full grid gap-y-0.5">
                        {personal.hasOwnProperty("occupations") &&
                          personal.occupations.length > 0 && (
                            <li className="w-full flex space-x-1.5">
                              <FiBriefcase
                                className="opacity-70 w-3.5 h-3.5"
                                style={{ color: primaryColor }}
                              />
                              <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                                {(personal.occupations || []).map(
                                  (val, index) => {
                                    const count = personal.occupations.length;
                                    if (index >= count - 1 && count !== 1) {
                                      return " and " + val;
                                    } else {
                                      if (index >= count - 2) {
                                        return val;
                                      } else {
                                        return val + ", ";
                                      }
                                    }
                                  }
                                )}
                              </p>
                            </li>
                          )}
                        {/* <li className="w-full flex space-x-1.5">
                          <BiBuildingHouse
                            className="opacity-70 w-3.5 h-3.5"
                            style={{ color: primaryColor }}
                          />
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            Agency Company
                          </p>
                        </li> */}
                        {personal.hasOwnProperty("profile_type") &&
                          personal.profile_type.length > 0 && (
                            <li className="w-full flex space-x-1.5">
                              <FaRegUserCircle
                                className="opacity-70 w-3.5 h-3.5"
                                style={{ color: primaryColor }}
                              />
                              <div className="w-full flex flex-row gap-x-2 items-center">
                                {(personal.profile_type || []).map(
                                  (value, index) => {
                                    let seperator = (index + 1) % 2 === 0;
                                    if (seperator) {
                                      return (
                                        <React.Fragment key={index}>
                                          <span className="text-xs opacity-30 leading-4">
                                            &#8226;
                                          </span>
                                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                                            {value}
                                          </p>
                                        </React.Fragment>
                                      );
                                    }
                                    return (
                                      <p
                                        className="text-xs text-resumeTempFourTextPrimary leading-4"
                                        key={index}>
                                        {value}
                                      </p>
                                    );
                                  }
                                )}
                              </div>
                            </li>
                          )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* Divider */}
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
              </div>
              {/*  More Information */}
              <div className="w-full">
                <p className="text-resumeTempFourTextPrimary text-md font-medium tracking-resumeFour">
                  More Information
                </p>
                <div className="w-full grid grid-cols-2 gap-x-6 mt-2">
                  {/* More Information */}
                  <div className="w-full grid gap-y-0.5">
                    {/* Date of Birth */}
                    {details && details.hasOwnProperty("birthdate") &&
                      details.birthdate && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Date of Birth
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {/* {moment(details.birthdate).format("DD MMMM YYYY")} 
                            */}
                            {moment(details.birthdate).format("D MMMM YYYY")}
                          </p>
                        </div>
                      )}
                    {/* Birth Location */}
                    {details && details.hasOwnProperty("birth_location") &&
                      details.birth_location && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Birth Location
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.birth_location}
                          </p>
                        </div>
                      )}

                    {/* Civil Status */}
                    {/* {details.hasOwnProperty("civil_status") &&
                      details.civil_status && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Civil Status
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.civil_status}
                          </p>
                        </div>
                      )} */}

                    {/* Children */}
                    {/* {details.hasOwnProperty("children") &&
                      details.children !== 0 && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Children
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.children} Children
                          </p>
                        </div>
                      )} */}
                    {/* Other Name */}
                    {details && details.hasOwnProperty("other_name") &&
                      details.other_name && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Other Name
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.other_name}
                          </p>
                        </div>
                      )}
                  </div>
                  {/* continue */}
                  <div className="w-full grid gap-y-0.5">
                    {/* Hair Color */}
                    {details && details.hasOwnProperty("hair_color") &&
                      details.hair_color && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Hair Color
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.hair_color}
                          </p>
                        </div>
                      )}
                    {/* Eye Color */}
                    {details && details.hasOwnProperty("eye_color") &&
                      details.eye_color && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Eye Color
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.eye_color}
                          </p>
                        </div>
                      )}

                    {/* Height */}
                    {details && details.hasOwnProperty("height") && details.height && (
                      <div className="w-full flex flex-row space-x-5.5">
                        <div className="w-21.5">
                          <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                            Height
                          </p>
                        </div>
                        <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                          {details.height}cm
                        </p>
                      </div>
                    )}

                    {/* Phone  */}
                    {details && details.hasOwnProperty("phone_number") &&
                      details.phone_number && (
                        <div className="w-full flex flex-row space-x-5.5">
                          <div className="w-21.5">
                            <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                              Phone
                            </p>
                          </div>
                          <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                            {details.phone_number}
                          </p>
                        </div>
                      )}
                    {/* Phone  */}
                    {details && details.hasOwnProperty("email") && details.email && (
                      <div className="w-full flex flex-row space-x-5.5">
                        <div className="w-21.5">
                          <p className="text-xs text-resumeTempFourTextSecondary leading-4">
                            Email Address
                          </p>
                        </div>
                        <p className="text-xs text-resumeTempFourTextPrimary leading-4">
                          {details.email}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Divider */}
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
              </div>
              {/*  */}
              {(details?.skills || (details && details.hasOwnProperty("occupations") &&
                !_.isEmpty(details?.occupations)) ||
                details?.education ||
                details?.training ||
                details?.experience) && (
                <div className="w-full grid gap-y-4">
                  {/*  */}
                  {details && details.hasOwnProperty("skills") && details.skills && (
                      <div className="w-full flex flex-row space-x-1 items-start">
                        <div className="w-66 flex flex-row space-x-2 items-center">
                          <UserGearIconSVG
                            className="w-5.5 h-5.5"
                            fill={primaryColor}
                          />
                          <p className="text-md text-resumeTempFourTextPrimary font-medium tracking-resumeFour">
                            Abilities / Skills / Specialties
                          </p>
                        </div>
                        <div style={{ width: "calc(100% - 296px)" }}>
                          <p className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch opacity-90 line-clamp-7">
                            {details.skills}
                          </p>
                        </div>
                      </div>
                    )}
                  {/*  */}
                  {details && details.hasOwnProperty("education") && details.education && (
                    <div className="w-full flex flex-row space-x-1 items-start">
                      <div className="w-66 flex flex-row space-x-2 items-center">
                        <GraduationCapIconSVG
                          className="w-5.5 h-5.5"
                          fill={primaryColor}
                        />
                        <p className="text-md text-resumeTempFourTextPrimary font-medium tracking-resumeFour">
                          Education
                        </p>
                      </div>
                      <div style={{ width: "calc(100% - 296px)" }}>
                        <p className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch opacity-90 line-clamp-7">
                          {details.education}
                        </p>
                      </div>
                    </div>
                  )}

                  {/*  */}
                  {details && details.hasOwnProperty("training") && details.training && (
                    <div className="w-full flex flex-row space-x-1 items-start">
                      <div className="w-66 flex flex-row space-x-2 items-center">
                        <ChatUserIconSVG
                          className="w-5.5 h-5.5"
                          fill={primaryColor}
                        />
                        <p className="text-md text-resumeTempFourTextPrimary font-medium tracking-resumeFour">
                          Training
                        </p>
                      </div>
                      <div style={{ width: "calc(100% - 296px)" }}>
                        <p className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch opacity-90 line-clamp-7">
                          {details.training}
                        </p>
                      </div>
                    </div>
                  )}
                  {/*  */}
                  {details && details.hasOwnProperty("experience") &&
                    details.experience && (
                      <div className="w-full flex flex-row space-x-1 items-start">
                        <div className="w-66 flex flex-row space-x-2 items-center">
                          <BriefCaseExperienceIconSVG
                            className="w-5.5 h-5.5"
                            fill={primaryColor}
                          />
                          <p className="text-md text-resumeTempFourTextPrimary font-medium tracking-resumeFour">
                            Experience
                          </p>
                        </div>
                        <div style={{ width: "calc(100% - 296px)" }}>
                          <p className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch opacity-90 line-clamp-7">
                            {details.experience}
                          </p>
                        </div>
                      </div>
                    )}
                    {details && details.hasOwnProperty("awards") &&
                      details.awards && (
                        <div className="w-full flex flex-row space-x-1 items-start">
                          <div className="w-66 flex flex-row space-x-2 items-center">
                            <AwardsIconSVG
                              className="w-5.5 h-5.5"
                              fill={primaryColor}
                            />
                            <p className="text-md text-resumeTempFourTextPrimary font-medium tracking-resumeFour line-clamp-7">
                              Awards
                            </p>
                          </div>
                          <div style={{ width: "calc(100% - 296px)" }}>
                            <p className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch opacity-90 line-clamp-7">
                              {details.awards}
                            </p>
                          </div>
                        </div>
                      )}
                      {details && details.hasOwnProperty("representation") &&
                      details.representation && (
                        <div className="w-full flex flex-row space-x-1 items-start">
                          <div className="w-66 flex flex-row space-x-2 items-center">
                            <FileUserRepresentationIconSVG
                              className="w-5.5 h-5.5"
                              fill={primaryColor}
                            />
                            <p className="text-md text-resumeTempFourTextPrimary font-medium tracking-resumeFour">
                              Representation
                            </p>
                          </div>
                          <div style={{ width: "calc(100% - 296px)" }}>
                            <p className="text-6xs text-resumeTempFourTextPrimary tracking-resume leading-4 self-stretch opacity-90 line-clamp-7">
                              {details.representation}
                            </p>
                          </div>
                        </div>
                      )}
                </div>
              )}
              <div className="w-full">
                <ResumeLineDividerIconSVG full={true} />
              </div>
              <div className="w-full">
                
                {/** social links */}
                {!_.isEmpty(social) && (
                  <>
                    <p className="text-resumeTempFourTextPrimary text-md font-medium tracking-resumeFour">
                      Follow Me
                    </p>
                    <div className="flex flex-col space-x-2 mb-8">
                    <div className="flex justify-start flex-wrap">
                      {Array.isArray(social) && (social || []).map((obj, index) => {
                          return (
                            <div
                              className="flex flex-row items-center break-all space-x-4 space-y-4 my-2"
                              key={index}>
                              <Favicon domain={obj.value} hasFavIconFile={obj.icon} width="w-[28px]"/>
                              <div className="leading-1">
                                {/* <span className="text-6xs text-resumeTempFourTextPrimary">
                                  {obj.value}
                                </span> */}
                              </div>
                            </div>
                          );
                      })}
                    </div>
                  </div>
                  </>
                  
                )}
              </div>
              {/* end */}
            </div> 
          </div>
          {/* footer */}
        <div className="w-full flex items-end">
          <div className="w-full">
            <ResumeLineDividerIconSVG full={true} />
            <div className="w-full grid pt-3.5 justify-center">
              <p className="text-xs text-resumeTempFourTextPrimary leading-4 opacity-90">
                Page 1 of {totalPage}
              </p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
